<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-card header="Search For Workers" header-tag="h4" body-class="mb-3 record_card_body">
          <ValidationObserver ref="resourcingSearch" slim>
            <form role="form" @submit.prevent="resourcing_search" class="row">
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Job Title" tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="job_title">Job Titles</label>
                <multiselect v-model="job_titles" tag-placeholder="" id="job_title" name="job_title" placeholder="" label="name" track-by="name" :class="classes"
                             :options="ms_opts.job_titles" :multiple="true" :taggable="true" @tag="addJobTitlesTag">
                  <span slot="noOptions">No Job Titles Selected...</span>
                </multiselect>
                <div v-if="errors[0]" class="vvERROR">You must enter at least one job title</div>
              </ValidationProvider>
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Location" tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="location">Location</label>
                <multiselect v-model="locations" tag-placeholder="" id="location" name="location" placeholder="" label="name" track-by="name" :class="classes"
                             :options="ms_opts.locations" :multiple="true" :taggable="true" @tag="addLocationsTag">
                  <span slot="noOptions">No Locations Selected...</span>
                </multiselect>
                <div v-if="errors[0]" class="vvERROR">You must enter at least one location</div>
              </ValidationProvider>
              <div class="col-12">
                <button type="submit" class="btn orcaBtn w-100" :disabled="searching">
                  <span v-if="searching" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>SEARCHING ...</span>
                  <span v-else>SEARCH</span>
                </button>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-card header="Search Results" header-tag="h4" body-class="mb-3 record_card_body">
          <datatable :type="'search_workers'" :rowData="search_results" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"></datatable>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import datatable from "datatables/datatable";

export default {
  name: "resourcing_search_workers",
  components: {
    Multiselect,
    datatable,
    'assignmentComponent': {
      name: 'assignmentComponent',
      template: '<div>' +
          '<div v-for="ass in params.data.previous_assignments"> ' +
          '{{ass}}' +
          ' </div>' +
          '</div>'
    }
  },
  data() {
    return {
      ms_opts: {
        locations: [],
        job_titles: []
      },
      locations: [],
      job_titles: [],

      search_results: [],

      loadingMessage: 'Loading Workers...',
      noRowsMessage: 'No Workers Found',
      columns: [
          {headerName: 'Finance Ref (id)', suppressSizeToFit: true, pinned: 'left', valueGetter: this.id},
          {headerName: 'Name', minWidth: 175, pinned: 'left', valueGetter: this.full_name_vg},
          {headerName: 'Status', field: 'status', pinned: 'left', minWidth: 75},
          {headerName: 'Town', field: 'city_town', minWidth: 75},
          {headerName: 'County', field: 'county', minWidth: 75},
          {headerName: 'Job Title', minWidth: 150, field: 'job_title'},
          {headerName: 'Last Log', minWidth: 75, valueGetter: this.last_log},
          {headerName: 'Updated', minWidth: 75, valueGetter: this.worker_updated},
          {headerName: 'Created', minWidth: 75, valueGetter: this.worker_created},
          {headerName: 'Last Note', minWidth: 400, field: 'last_note'},
          {headerName: 'Address', field: 'address', minWidth: 200},
          {headerName: 'Previous Assignments', minWidth: 250, field: 'previous_assignments', cellRendererFramework: 'assignmentComponent'}
      ],
      searching: false
    }
  },
  methods: {
    addLocationsTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.ms_opts.locations.push(tag)
      this.locations.push(tag)
    },
    addJobTitlesTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.ms_opts.job_titles.push(tag)
      this.job_titles.push(tag)
    },
    resourcing_search() {
      this.$refs.resourcingSearch.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.resourcingSearch);
        }
        else {
          this.searching = true;
          this.search_results = [];
          axios.post(this.crmApiPath + 'resourcing/worker/search', {
            'locations': this.locations,
            'job_titles': this.job_titles
          }).then(res => {
            this.search_results = res.data;
            this.$nextTick(() => this.searching = false)
          })
        }
      });
    },
    id(params) {
      return params.data.id + ' (' + params.data.id + ')';
    },
    full_name_vg(params) {
      return params.data.first_name + ' ' + params.data.surname;
    },
    last_log(params) {
      return params.data.last_log !== null ? this.$options.filters.formatDateTime(params.data.last_log) : '';
    },
    worker_updated(params) {
      return params.data.updated_at !== null ? this.$options.filters.formatDateTime(params.data.updated_at) : '';
    },
    worker_created(params) {
      return params.data.created_at !== null ? this.$options.filters.formatDateTime(params.data.created_at) : '';
    }
  }
}
</script>

<style scoped>

</style>
